export default "* Papir\n* Farveblyanter\n* Evt. lamineringslommer\n* Evt. lamineringsmaskine";